import { Card } from "@mui/material";
import React from "react";
/**
 * Card container used by the Settings-module mobile cards
 * (users, roles, company configurations, permissions).
 */
export const SettingCardWrapper = ({ children, onClick, }) => {
    return (React.createElement(Card, { onClick: onClick, sx: {
            cursor: onClick ? "pointer" : "default",
            background: "#FFFFFF",
            borderRadius: "16px",
            padding: 1.5,
            boxShadow: " 0px 12px 24px -4px #919EAB1F,0px 0px 2px 0px #919EAB33",
            "&:hover": onClick
                ? {
                    backgroundColor: "action.hover",
                }
                : {},
        } }, children));
};
